import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-empty-data',
  templateUrl: './empty-data.component.html',
})
export class EmptyDataComponent {

  @Output() onAdd = new EventEmitter<any>();

  @Input() emptyTitle = 'No Data Available';

  @Input() emptyDescription = 'There is no data to show you right now.';

  @Input() btnTitle = 'Add one';

  @Input() showAddBtn = false;

}
